import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    const hostname = window.location.hostname;

    if (hostname.includes('localhost')) {
      this.baseUrl = 'http://localhost:3000/api';
    } else if (hostname.includes('dev10.in')) {
      this.baseUrl = 'https://docapi.dev10.in/api';
    } else {
      // Default or fallback
      this.baseUrl = 'https://docapi.dev10.in/api';
    }
  }

  private buildUrl(endpoint: string): string {
    // avoid double slashes
    return `${this.baseUrl}/${endpoint.replace(/^\/+/, '')}`;
  }

  // ✅ Generic HTTP wrappers
  get<T>(endpoint: string, params?: any): Observable<T> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.set(key, params[key]);
      });
    }
    return this.http.get<T>(this.buildUrl(endpoint), { params: httpParams });
  }

  post<T>(endpoint: string, data: any, options?: any): Observable<T> {
    return this.http.post(this.buildUrl(endpoint), data, options) as Observable<T>;
  }

  put<T>(endpoint: string, data: any): Observable<T> {
    return this.http.put<T>(this.buildUrl(endpoint), data);
  }

  patch<T>(endpoint: string, data: any): Observable<T> {
    return this.http.patch<T>(this.buildUrl(endpoint), data);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(this.buildUrl(endpoint));
  }

  // Dedicated UMS login API (bypasses baseUrl)
  loginApi(body: any): Observable<any> {
    const loginUrl = 'https://umsapinode.dev10.in/login'; // ✅ full URL
    const headers = new HttpHeaders({
      'City-Id': '13',
      'User-Lang': 'en',
      'App-Id': '15',
    });

    return this.http.post(loginUrl, body, { headers });
  }
}
